import { get } from 'lodash-es'

import API_CONSTANTS from '@/js/helper/api-constants.js'
import AIMEOS_META_CONSTANTS from '@/js/helper/aimeos-meta-constants.js'
import GETTER_TYPES from '../getter-types'
import { REQUEST_STATE } from '@/js/plugins/store/modules/aimeos/constants'

export const getCompareGetters = MUTATION_TYPES => ({
  [GETTER_TYPES.OPTIONS_COMPARE_URL]: state =>
    get(
      state,
      [
        MUTATION_TYPES.OPTIONS.dataKey,
        API_CONSTANTS.META.TYPE,
        ...AIMEOS_META_CONSTANTS.PATHS.COMPARE,
      ],
      '',
    ),
  [GETTER_TYPES.COMPARE_PENDING]: state =>
    get(state, MUTATION_TYPES.COMPARE.stateKey, REQUEST_STATE.STATE_FAILURE) ===
    REQUEST_STATE.STATE_PENDING,
  [GETTER_TYPES.COMPARE_COUNT]: state =>
    get(state, [MUTATION_TYPES.COMPARE.dataKey, API_CONSTANTS.DATA], []).length,
  [GETTER_TYPES.COMPARE_DATA]: state =>
    get(state, [MUTATION_TYPES.COMPARE.dataKey, API_CONSTANTS.DATA], []),
  [GETTER_TYPES.COMPARE_DATA_RAW]: state => get(state, [MUTATION_TYPES.COMPARE.dataKey], []),
  [GETTER_TYPES.COMPARE_PRODUCT_IDS]: state => {
    return get(state, [MUTATION_TYPES.COMPARE.dataKey, API_CONSTANTS.DATA], []).map(item => item.id)
  },
  [GETTER_TYPES.COMPARE_PRODUCT_URL]: (state, getters) => {
    const urlFilterParts = getters[GETTER_TYPES.COMPARE_PRODUCT_IDS]
      .map(id => `ai%5Bfilter%5D%5B%3D%3D%5D%5Bproduct.id%5D%5B%5D=${id}`)
      .join('&')

    return getters[GETTER_TYPES.COMPARE_PRODUCT_IDS].length
      ? `${getters[GETTER_TYPES.OPTIONS_PRODUCT_URL]}${
          /\?/.test(getters[GETTER_TYPES.OPTIONS_PRODUCT_URL]) ? '&' : '?'
        }ai%5Binclude%5D=media%2Cprice%2Cproduct%2Fproperty&${urlFilterParts}`
      : undefined
  },
})
